export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    {index: 0, label: 'Home',   url: '/',      labelIcon: 'HomeIcon',     highlightAction: false},
    {index: 1, label: 'Checkout', url: '/checkout', labelIcon: 'CheckSquareIcon', highlightAction: false},
    {index: 2, label: 'Customer', url: '/customer', labelIcon: 'UserIcon', highlightAction: false},
    {index: 3, label: 'Staff', url: '/staff', labelIcon: 'UserIcon', highlightAction: false},
  ]
}
